/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Action_View_ConversationInputs */

const en_notifications_action_view_conversation = /** @type {(inputs: Notifications_Action_View_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View conversation`)
};

const pt_br2_notifications_action_view_conversation = /** @type {(inputs: Notifications_Action_View_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver conversa`)
};

/**
* | output |
* | --- |
* | "View conversation" |
*
* @param {Notifications_Action_View_ConversationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_action_view_conversation = /** @type {((inputs?: Notifications_Action_View_ConversationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Action_View_ConversationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_action_view_conversation(inputs)
	return pt_br2_notifications_action_view_conversation(inputs)
});